module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/3rdparty/Decoder.worker.a07bd3b87457d8dccbc3.js");
}
